function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo30Years(_ref, svgRef) {
  var _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41;
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 291,
    height: 58,
    viewBox: "0 0 291 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M29.0102 43.5C37.0212 43.5 43.5154 37.0081 43.5154 29C43.5154 20.9919 37.0212 14.5 29.0102 14.5C20.9993 14.5 14.5051 20.9919 14.5051 29C14.5051 37.0081 20.9993 43.5 29.0102 43.5Z",
    fill: "url(#paint0_linear_5186_1620)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0102 43.5C37.0212 43.5 43.5154 37.0081 43.5154 29C43.5154 20.9919 37.0212 14.5 29.0102 14.5C20.9993 14.5 14.5051 20.9919 14.5051 29C14.5051 37.0081 20.9993 43.5 29.0102 43.5Z",
    fill: "url(#paint1_linear_5186_1620)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0853 16.976C16.2629 21.3611 16.7862 29.2619 22.2557 34.621C27.7232 39.9801 36.0645 40.7715 40.8888 36.3845C41.4354 35.8875 41.9133 35.3454 42.3232 34.767C43.0904 32.9996 43.5157 31.0495 43.5157 29C43.5157 20.9919 37.0216 14.5 29.0106 14.5C26.3143 14.5 23.7898 15.2354 21.627 16.5166C21.4419 16.6628 21.2613 16.816 21.0853 16.976Z",
    fill: "url(#paint2_radial_5186_1620)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0699 16.9751C19.7874 20.4501 22.4455 25.8504 28.0077 29.0337C33.57 32.2189 39.9273 31.9826 42.2117 28.5057C42.8568 27.5238 43.1077 26.3886 43.0104 25.1932C41.3378 19.0317 35.7035 14.5 29.0104 14.5C26.9891 14.5 25.0644 14.9133 23.3162 15.66C22.8238 16.0289 22.4033 16.4675 22.0699 16.9751Z",
    fill: "url(#paint3_linear_5186_1620)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9898 35.3092C88.8475 36.1717 89.8608 36.8501 91.0299 37.3473C92.1989 37.8444 93.499 38.1053 94.9002 38.1108C95.9381 38.1108 96.9515 37.9543 97.9129 37.6137C98.8744 37.2978 99.7566 36.8556 100.562 36.2541C101.344 35.68 102.018 34.9741 102.589 34.1639C103.16 33.3564 103.575 32.4664 103.835 31.4749H99.7566C99.5763 31.9446 99.3168 32.3621 98.9781 32.7274C98.6394 33.0927 98.2516 33.4058 97.8091 33.642C97.3666 33.903 96.9269 34.1117 96.4325 34.2436C95.9382 34.3726 95.4192 34.4523 94.9002 34.4523C94.018 34.4523 93.2122 34.2958 92.5103 33.9826C91.781 33.697 91.1582 33.2795 90.6392 32.7301C90.1203 32.1808 89.7325 31.5545 89.4457 30.8486C89.1616 30.1455 89.0305 29.36 89.0305 28.525C89.0305 27.69 89.1589 26.9072 89.4457 26.2013C89.7297 25.4954 90.1203 24.8692 90.6392 24.3198C91.1609 23.7705 91.7837 23.353 92.5103 23.0399C93.2122 22.7515 94.018 22.5949 94.9002 22.5949C95.4192 22.5949 95.9382 22.6718 96.4325 22.8037C96.9269 22.9328 97.3666 23.1415 97.8091 23.3777C98.2516 23.6387 98.6394 23.9518 98.9781 24.3171C99.3141 24.6824 99.5736 25.0999 99.7566 25.5696H103.835C103.575 24.578 103.16 23.6634 102.589 22.8532C102.018 22.0429 101.341 21.3644 100.562 20.7629C99.7566 20.1861 98.8744 19.7439 97.9129 19.4033C96.9515 19.0902 95.9381 18.9337 94.9002 18.9337C93.4963 18.9337 92.1989 19.1671 91.0299 19.6643C89.8608 20.1614 88.8475 20.8398 87.9898 21.7023C87.1322 22.5647 86.4575 23.5838 85.9632 24.7593C85.4715 25.9349 85.2366 27.1874 85.2366 28.5195C85.2366 29.8516 85.4688 31.1041 85.9632 32.2796C86.4575 33.4552 87.1322 34.4468 87.9898 35.3092Z",
    fill: "#006DFF",
    style: (_ref2 = {
      fill: "#006DFF"
    }, _defineProperty(_ref2, "fill", "color(display-p3 0.0000 0.4262 1.0000)"), _defineProperty(_ref2, "fillOpacity", 1), _ref2)
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.1158 27.7905C63.5705 27.2923 62.897 26.9014 62.1445 26.6124C61.3674 26.3262 60.5385 26.1941 59.6306 26.1913H54.36V22.8417H64.3231V19.2306H50.5754V37.8146H59.6306C60.5358 37.8146 61.3674 37.6577 62.1445 37.3687C62.897 37.0825 63.5705 36.6889 64.1158 36.1659C64.6612 35.6677 65.1002 35.0402 65.4383 34.3329C65.7491 33.6283 65.9045 32.8686 65.9045 32.0044C65.9045 31.1401 65.7491 30.3557 65.4383 29.6483C65.1002 28.941 64.6612 28.3134 64.1158 27.7905ZM59.5788 29.6758C60.3831 29.6758 61.0294 29.885 61.5229 30.2786C62.0164 30.6695 62.2481 31.2447 62.2481 32.0044C62.2481 32.764 62.0164 33.3117 61.5229 33.7053C61.0294 34.0989 60.3831 34.3081 59.5788 34.3081H54.36V29.6758H59.5788Z",
    fill: "#006DFF",
    style: (_ref3 = {
      fill: "#006DFF"
    }, _defineProperty(_ref3, "fill", "color(display-p3 0.0000 0.4262 1.0000)"), _defineProperty(_ref3, "fillOpacity", 1), _ref3)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.794 19.2382V26.8021H120.897L125.222 21.3588V26.8021H126.487V19.2382H125.384L121.07 24.6723V19.2382H119.794Z",
    fill: "#006DFF",
    style: (_ref4 = {
      fill: "#006DFF"
    }, _defineProperty(_ref4, "fill", "color(display-p3 0.0000 0.4262 1.0000)"), _defineProperty(_ref4, "fillOpacity", 1), _ref4)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.456 22.8178L110.774 19.2389H109.617V26.8028H110.882V21.3687L113.467 24.8103L116.03 21.3797V26.8028H117.306V19.2389H116.149L113.456 22.8178Z",
    fill: "#006DFF",
    style: (_ref5 = {
      fill: "#006DFF"
    }, _defineProperty(_ref5, "fill", "color(display-p3 0.0000 0.4262 1.0000)"), _defineProperty(_ref5, "fillOpacity", 1), _ref5)
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.414 24.182H130.235V26.8021H128.97V19.2382H131.414C132.992 19.2382 134.073 20.3141 134.073 21.7101C134.073 23.1062 132.992 24.182 131.414 24.182ZM131.403 20.4111H130.235V23.011H131.403C132.311 23.011 132.831 22.4456 132.831 21.712C132.831 20.9746 132.311 20.4111 131.403 20.4111Z",
    fill: "#006DFF",
    style: (_ref6 = {
      fill: "#006DFF"
    }, _defineProperty(_ref6, "fill", "color(display-p3 0.0000 0.4262 1.0000)"), _defineProperty(_ref6, "fillOpacity", 1), _ref6)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.617 29.8831V37.4469H110.72L115.045 32.0037V37.4469H116.31V29.8831H115.207L110.893 35.3172V29.8831H109.617Z",
    fill: "#006DFF",
    style: (_ref7 = {
      fill: "#006DFF"
    }, _defineProperty(_ref7, "fill", "color(display-p3 0.0000 0.4262 1.0000)"), _defineProperty(_ref7, "fillOpacity", 1), _ref7)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.793 29.8831H120.058V33.0155H123.854V29.8831H125.118V37.4469H123.854V34.1974H120.058V37.4469H118.793V29.8831Z",
    fill: "#006DFF",
    style: (_ref8 = {
      fill: "#006DFF"
    }, _defineProperty(_ref8, "fill", "color(display-p3 0.0000 0.4262 1.0000)"), _defineProperty(_ref8, "fillOpacity", 1), _ref8)
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.258 29.8831H127.61V37.4469H130.594C132.054 37.4469 133.07 36.4772 133.07 35.2312C133.07 34.2944 132.539 33.7181 131.837 33.4308C132.258 33.1216 132.55 32.6532 132.55 31.9707C132.55 30.8309 131.632 29.8831 130.258 29.8831ZM131.307 32.0457C131.307 32.6312 130.886 33.0685 130.193 33.0685H128.874V31.023H130.193C130.886 31.023 131.307 31.4914 131.307 32.0457ZM131.837 35.2202C131.837 35.8588 131.383 36.307 130.561 36.307H128.874V34.1334H130.561C131.382 34.1334 131.837 34.5908 131.837 35.2202Z",
    fill: "#006DFF",
    style: (_ref9 = {
      fill: "#006DFF"
    }, _defineProperty(_ref9, "fill", "color(display-p3 0.0000 0.4262 1.0000)"), _defineProperty(_ref9, "fillOpacity", 1), _ref9)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.078 29.8831H139.695V31.076H136.343V33.0155H139.047V34.2084H136.343V36.254H139.695V37.4469H135.078V29.8831Z",
    fill: "#006DFF",
    style: (_ref10 = {
      fill: "#006DFF"
    }, _defineProperty(_ref10, "fill", "color(display-p3 0.0000 0.4262 1.0000)"), _defineProperty(_ref10, "fillOpacity", 1), _ref10)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.121 29.7552C142.829 29.7552 141.12 31.4495 141.12 33.6652C141.12 35.881 142.829 37.5752 145.121 37.5752C146.969 37.5752 148.44 36.3914 148.818 34.9112H147.455C147.13 35.7748 146.2 36.3713 145.119 36.3713C143.52 36.3713 142.394 35.1894 142.394 33.6652C142.394 32.1411 143.518 30.9592 145.119 30.9592C146.202 30.9592 147.13 31.5556 147.455 32.4192H148.818C148.441 30.9372 146.971 29.7552 145.121 29.7552Z",
    fill: "#006DFF",
    style: (_ref11 = {
      fill: "#006DFF"
    }, _defineProperty(_ref11, "fill", "color(display-p3 0.0000 0.4262 1.0000)"), _defineProperty(_ref11, "fillOpacity", 1), _ref11)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.255 31.076H150.027V29.8831H155.758V31.076H153.52V37.4469H152.255V31.076Z",
    fill: "#006DFF",
    style: (_ref12 = {
      fill: "#006DFF"
    }, _defineProperty(_ref12, "fill", "color(display-p3 0.0000 0.4262 1.0000)"), _defineProperty(_ref12, "fillOpacity", 1), _ref12)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.556 29.8831V37.4469H158.659L162.985 32.0037V37.4469H164.249V29.8831H163.146L158.832 35.3172V29.8831H157.556Z",
    fill: "#006DFF",
    style: (_ref13 = {
      fill: "#006DFF"
    }, _defineProperty(_ref13, "fill", "color(display-p3 0.0000 0.4262 1.0000)"), _defineProperty(_ref13, "fillOpacity", 1), _ref13)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.696 36.254V39.0241H172.528V37.4469H166.732V29.8831H168.008V36.254H171.447V29.8831H172.723V36.254H173.696Z",
    fill: "#006DFF",
    style: (_ref14 = {
      fill: "#006DFF"
    }, _defineProperty(_ref14, "fill", "color(display-p3 0.0000 0.4262 1.0000)"), _defineProperty(_ref14, "fillOpacity", 1), _ref14)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.613 29.8831V37.4469H176.716L181.042 32.0037V37.4469H182.307V29.8831H181.203L176.889 35.3172V29.8831H175.613Z",
    fill: "#006DFF",
    style: (_ref15 = {
      fill: "#006DFF"
    }, _defineProperty(_ref15, "fill", "color(display-p3 0.0000 0.4262 1.0000)"), _defineProperty(_ref15, "fillOpacity", 1), _ref15)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.791 37.4469V29.883H186.067V35.3171L190.381 29.883H191.484V37.4469H190.219V32.0036L185.894 37.4469H184.791Z",
    fill: "#006DFF",
    style: (_ref16 = {
      fill: "#006DFF"
    }, _defineProperty(_ref16, "fill", "color(display-p3 0.0000 0.4262 1.0000)"), _defineProperty(_ref16, "fillOpacity", 1), _ref16)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.446 27.6344H187.278C187.278 28.2729 187.645 28.6681 188.24 28.6681C188.834 28.6681 189.202 28.2748 189.202 27.6344H190.034C190.034 28.7212 189.233 29.4037 188.238 29.4037C187.246 29.4037 186.446 28.7212 186.446 27.6344Z",
    fill: "#006DFF",
    style: (_ref17 = {
      fill: "#006DFF"
    }, _defineProperty(_ref17, "fill", "color(display-p3 0.0000 0.4262 1.0000)"), _defineProperty(_ref17, "fillOpacity", 1), _ref17)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9685 37.8146H69.3431V19.2306H72.9685V27.1079L79.4168 19.2306H83.924L76.5694 28.1565L85.4583 37.8146H80.7245L72.9685 29.3869V37.8146Z",
    fill: "#006DFF",
    style: (_ref18 = {
      fill: "#006DFF"
    }, _defineProperty(_ref18, "fill", "color(display-p3 0.0000 0.4262 1.0000)"), _defineProperty(_ref18, "fillOpacity", 1), _ref18)
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.873 43.5L198.873 14.5L200.018 14.5L200.018 43.5L198.873 43.5Z",
    fill: "#006DFF",
    style: (_ref19 = {
      fill: "#006DFF"
    }, _defineProperty(_ref19, "fill", "color(display-p3 0.0000 0.4262 1.0000)"), _defineProperty(_ref19, "fillOpacity", 1), _ref19)
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.853 28.6184C231.853 32.496 228.708 35.6393 224.829 35.6393C220.95 35.6393 217.806 32.496 217.806 28.6184C217.806 24.7409 220.95 21.5975 224.829 21.5975C228.708 21.5975 231.853 24.7409 231.853 28.6184ZM234.372 28.6184C234.372 33.8869 230.1 38.1579 224.829 38.1579C219.559 38.1579 215.286 33.8869 215.286 28.6184C215.286 23.3499 219.559 19.0789 224.829 19.0789C230.1 19.0789 234.372 23.3499 234.372 28.6184Z",
    fill: "url(#paint4_linear_5186_1620)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.76 35.8207C215.778 35.8207 217.293 34.652 217.293 32.6451C217.293 30.2824 215.538 29.4695 212.942 29.4695H212.101V26.9544H212.822C215.514 26.9544 216.86 26.0144 216.86 24.1091C216.86 22.2545 215.442 21.3908 213.832 21.3908C211.717 21.3908 210.539 22.7372 210.275 24.8966H207.487C207.751 21.3908 210.155 19.0789 214 19.0789C216.908 19.0789 219.792 20.4762 219.792 23.9313C219.792 25.7604 218.783 27.2847 217.245 28.0722C219.36 28.8852 220.249 30.6635 220.249 32.5689C220.249 36.3288 217.196 38.1579 213.712 38.1579C209.674 38.1579 207.463 35.3634 207.271 32.1116H210.058C210.323 34.1439 211.524 35.8207 213.76 35.8207Z",
    fill: "#006DFF",
    style: (_ref20 = {
      fill: "#006DFF"
    }, _defineProperty(_ref20, "fill", "color(display-p3 0.0000 0.4262 1.0000)"), _defineProperty(_ref20, "fillOpacity", 1), _ref20)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.381 20.4391V26.8099H256.628V20.4391H258.834V19.2459H253.186V20.4391H255.381Z",
    fill: "#006DFF",
    style: (_ref21 = {
      fill: "#006DFF"
    }, _defineProperty(_ref21, "fill", "color(display-p3 0.0000 0.4262 1.0000)"), _defineProperty(_ref21, "fillOpacity", 1), _ref21)
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.724 33.6655C245.724 35.8495 247.461 37.5754 249.635 37.5754C251.798 37.5754 253.546 35.8495 253.546 33.6655C253.546 31.4816 251.798 29.7557 249.635 29.7557C247.461 29.7557 245.724 31.4816 245.724 33.6655ZM252.278 33.6655C252.278 35.157 251.127 36.3715 249.635 36.3715C248.132 36.3715 246.981 35.157 246.981 33.6655C246.981 32.174 248.132 30.9595 249.635 30.9595C251.127 30.9595 252.278 32.174 252.278 33.6655Z",
    fill: "#006DFF",
    style: (_ref22 = {
      fill: "#006DFF"
    }, _defineProperty(_ref22, "fill", "color(display-p3 0.0000 0.4262 1.0000)"), _defineProperty(_ref22, "fillOpacity", 1), _ref22)
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.542 32.8771H258.173C259.643 32.8771 260.741 33.7507 260.741 35.1676C260.741 36.5633 259.643 37.4475 258.173 37.4475H255.285V29.8835H260.059V31.0767H256.542V32.8771ZM259.505 35.1676C259.505 34.4326 259.015 34.0277 258.162 34.0277H256.542V36.2863H258.162C259.015 36.2863 259.505 35.8921 259.505 35.1676Z",
    fill: "#006DFF",
    style: (_ref23 = {
      fill: "#006DFF"
    }, _defineProperty(_ref23, "fill", "color(display-p3 0.0000 0.4262 1.0000)"), _defineProperty(_ref23, "fillOpacity", 1), _ref23)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.75 29.8835V37.4475H267.3V36.2543H263.996V34.2088H266.661V33.0156H263.996V31.0767H267.3V29.8835H262.75Z",
    fill: "#006DFF",
    style: (_ref24 = {
      fill: "#006DFF"
    }, _defineProperty(_ref24, "fill", "color(display-p3 0.0000 0.4262 1.0000)"), _defineProperty(_ref24, "fillOpacity", 1), _ref24)
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M275.22 37.4475V39.0242H276.361V36.2543H275.401V29.8835H269.998V33.8573C269.998 35.7749 269.54 36.2543 269.028 36.2543H268.89V39.0242H270.03V37.4475H275.22ZM271.256 34.0064V31.0767H274.154V36.2543H270.808C271.096 35.7855 271.256 35.157 271.256 34.0064Z",
    fill: "#006DFF",
    style: (_ref25 = {
      fill: "#006DFF"
    }, _defineProperty(_ref25, "fill", "color(display-p3 0.0000 0.4262 1.0000)"), _defineProperty(_ref25, "fillOpacity", 1), _ref25)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.741 37.4473V31.0765H239.107V37.4473H237.87V29.8833H243.977V37.4473H242.741Z",
    fill: "#006DFF",
    style: (_ref26 = {
      fill: "#006DFF"
    }, _defineProperty(_ref26, "fill", "color(display-p3 0.0000 0.4262 1.0000)"), _defineProperty(_ref26, "fillOpacity", 1), _ref26)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.174 26.8099V19.2459H251.724V20.4391H248.42V22.378H251.085V23.5712H248.42V25.6167H251.724V26.8099H247.174Z",
    fill: "#006DFF",
    style: (_ref27 = {
      fill: "#006DFF"
    }, _defineProperty(_ref27, "fill", "color(display-p3 0.0000 0.4262 1.0000)"), _defineProperty(_ref27, "fillOpacity", 1), _ref27)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.149 19.2459V24.4128C239.149 25.4995 238.872 25.7658 238.361 25.7658C238.169 25.7658 238.009 25.7552 237.87 25.7339V26.8951C238.03 26.927 238.254 26.9377 238.52 26.9377C239.65 26.9377 240.407 26.2133 240.407 24.5833V20.4391H243.306V26.8099H244.563V19.2459H239.149Z",
    fill: "#006DFF",
    style: (_ref28 = {
      fill: "#006DFF"
    }, _defineProperty(_ref28, "fill", "color(display-p3 0.0000 0.4262 1.0000)"), _defineProperty(_ref28, "fillOpacity", 1), _ref28)
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5186_1620",
    x1: 28.6476,
    y1: 43.1375,
    x2: 28.8602,
    y2: 16.1591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E66E6",
    style: (_ref29 = {
      stopColor: "#1E66E6"
    }, _defineProperty(_ref29, "stopColor", "color(display-p3 0.1163 0.4017 0.9000)"), _defineProperty(_ref29, "stopOpacity", 1), _ref29)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "#8CB4F2",
    style: (_ref30 = {
      stopColor: "#8CB4F2"
    }, _defineProperty(_ref30, "stopColor", "color(display-p3 0.5490 0.7059 0.9490)"), _defineProperty(_ref30, "stopOpacity", 1), _ref30)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F7FE",
    style: (_ref31 = {
      stopColor: "#F1F7FE"
    }, _defineProperty(_ref31, "stopColor", "color(display-p3 0.9451 0.9686 0.9961)"), _defineProperty(_ref31, "stopOpacity", 1), _ref31)
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5186_1620",
    x1: 41.3396,
    y1: 35.525,
    x2: 26.1132,
    y2: 23.9198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D87EA",
    style: (_ref32 = {
      stopColor: "#4D87EA"
    }, _defineProperty(_ref32, "stopColor", "color(display-p3 0.3020 0.5294 0.9176)"), _defineProperty(_ref32, "stopOpacity", 1), _ref32)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7EAAF0",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_5186_1620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.1909 32.4111) rotate(-152.961) scale(34.5322 71.1856)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.103242,
    stopColor: "#4382EF",
    style: (_ref33 = {
      stopColor: "#4382EF"
    }, _defineProperty(_ref33, "stopColor", "color(display-p3 0.2617 0.5098 0.9375)"), _defineProperty(_ref33, "stopOpacity", 1), _ref33)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.459935,
    stopColor: "#7EAAF0",
    style: (_ref34 = {
      stopColor: "#7EAAF0"
    }, _defineProperty(_ref34, "stopColor", "color(display-p3 0.4941 0.6667 0.9412)"), _defineProperty(_ref34, "stopOpacity", 1), _ref34)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630708,
    stopColor: "#B2CDF6",
    style: (_ref35 = {
      stopColor: "#B2CDF6"
    }, _defineProperty(_ref35, "stopColor", "color(display-p3 0.6980 0.8039 0.9647)"), _defineProperty(_ref35, "stopOpacity", 1), _ref35)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794216,
    stopColor: "#F0F6FD",
    style: (_ref36 = {
      stopColor: "#F0F6FD"
    }, _defineProperty(_ref36, "stopColor", "color(display-p3 0.9412 0.9647 0.9922)"), _defineProperty(_ref36, "stopOpacity", 1), _ref36)
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5186_1620",
    x1: 41.6744,
    y1: 19.5677,
    x2: 21.0328,
    y2: 22.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CBFF4",
    style: (_ref37 = {
      stopColor: "#9CBFF4"
    }, _defineProperty(_ref37, "stopColor", "color(display-p3 0.6118 0.7490 0.9569)"), _defineProperty(_ref37, "stopOpacity", 1), _ref37)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476252,
    stopColor: "#CCE0FD",
    style: (_ref38 = {
      stopColor: "#CCE0FD"
    }, _defineProperty(_ref38, "stopColor", "color(display-p3 0.8000 0.8784 0.9922)"), _defineProperty(_ref38, "stopOpacity", 1), _ref38)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.770833,
    stopColor: "#E9F2FE",
    style: (_ref39 = {
      stopColor: "#E9F2FE"
    }, _defineProperty(_ref39, "stopColor", "color(display-p3 0.9137 0.9490 0.9961)"), _defineProperty(_ref39, "stopOpacity", 1), _ref39)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F7FE",
    style: (_ref40 = {
      stopColor: "#F1F7FE"
    }, _defineProperty(_ref40, "stopColor", "color(display-p3 0.9451 0.9686 0.9961)"), _defineProperty(_ref40, "stopOpacity", 1), _ref40)
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5186_1620",
    x1: 224.834,
    y1: 32.5862,
    x2: 216.469,
    y2: 32.5862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006DFF",
    style: (_ref41 = {
      stopColor: "#006DFF"
    }, _defineProperty(_ref41, "stopColor", "color(display-p3 0.0000 0.4262 1.0000)"), _defineProperty(_ref41, "stopOpacity", 1), _ref41)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006DFF",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo30Years);
export default __webpack_public_path__ + "static/media/logo_30_years.3cf61b13638269eb18b249d581fa8219.svg";
export { ForwardRef as ReactComponent };